module.exports = __webpack_public_path__ + "static/media/Степанов А., Чуновкина А. (ММ).63fd148e.pdf";